<template>
  <div class="card">
    <!-- header: título y rango seleccionado -->
    

    <div class="card-body">
      <!-- botones de filtro -->
        <div class="d-flex gap-2 mb-2 align-items-center justify-content-between">
            <div class="d-flex gap-2 align-items-center">
                <b-button size="sm" :variant="tipoReporte === 1 ? 'primary' : 'outline-primary'" @click="onClickTipo(1)">12 h</b-button>
                <b-button size="sm" :variant="tipoReporte === 2 ? 'primary' : 'outline-primary'" @click="onClickTipo(2)">24 h</b-button>
                <b-button size="sm" :variant="tipoReporte === 3 ? 'primary' : 'outline-primary'" @click="onClickTipo(3)">48 h</b-button>
                <b-button size="sm" :variant="tipoReporte === 4 ? 'primary' : 'outline-primary'" @click="onClickTipo(4)">72 h</b-button>
            </div>

            <!-- Botón de refresh alineado a la derecha -->
            <b-button 
                size="sm" 
                variant="outline-primary" 
                @click="refreshData"
                :disabled="loading"
                title="Actualizar datos"
                class="refresh-btn"
            >
                <b-icon icon="arrow-clockwise" :animation="loading ? 'spin' : ''" aria-hidden="true"></b-icon>
            </b-button>
            
            <!-- abrir modal para seleccionar fechas (muestra activo cuando tipoReporte === 5) -->
            <!--<b-button size="sm" :variant="tipoReporte === 5 ? 'primary' : 'outline-secondary'" @click="openFechaModal">
              Filtro fechas
            </b-button>
            <b-button size="sm" variant="outline-secondary" class="ms-1" @click="limpiarFiltro">
              Limpiar
            </b-button>-->
        </div>

        <div class="">
            <div v-if="loading" class="spinner-wrap">
              <b-spinner label="Cargando..." variant="primary" style="width: 2rem; height: 2rem;"></b-spinner>
            </div>

            <div v-else class="chart-container">
              <div class="chart-wrapper">
                  <ChartLine :data="chartData" :title="title" :height="200" titleEjeY="kWh" />
                  <!-- ✅ AÑADIR ESTE DIV PARA LAS ETIQUETAS PERSONALIZADAS -->
                  <div v-if="intervalLabels.length > 0" class="custom-x-axis">
                    <div v-for="(label, index) in intervalLabels" :key="index" class="axis-label" :style="getAxisLabelStyle(index)">
                      <div class="label-hora">{{ label.hora }}</div>
                      <div v-if="label.showDate" class="label-fecha">{{ label.fecha }}</div>
                    </div>
                  </div>
              </div>
            </div>
            <!-- envoltorio responsivo que controla tamaño del canvas -->
        </div>
    </div>

    <!-- Modal para seleccionar rango de fechas -->
    <b-modal v-model="showModal" title="Seleccionar rango de fechas" hide-footer size="lg" centered>
        <div class="mb-3">
            <label class="form-label">Desde</label>
            <input type="datetime-local" class="form-control" v-model="fechaInicioLocal" />
        </div>
        <div class="mb-3">
            <label class="form-label">Hasta</label>
            <input type="datetime-local" class="form-control" v-model="fechaFinLocal" />
        </div>

        <div class="d-flex justify-content-end">
            <b-button size="sm" variant="secondary" class="me-2" @click="onLimpiarModal">Limpiar</b-button>
            <b-button size="sm" variant="outline-secondary" class="me-2" @click="closeModal">Cancelar</b-button>
            <b-button size="sm" variant="success" :disabled="!fechasValidas" @click="confirmarFiltro">Aplicar</b-button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import ChartLine from '@/components/Charts/ChartLine.vue';

export default {
  name: 'ConsumoHora',
  components: { ChartLine },
  props: {
    // si el padre pasa lecturas, se usará como fallback/entrada inicial
    lecturas: { type: Array, default: () => [] },
    title: { type: String, default: 'Consumo de energia - hora' },
    // por defecto tipo_grafico = 1 según solicitud
    defaultTipoReporte: { type: Number, default: 1 }
  },
  data() {
    return {
      labels: [],
      values: [],
      loading: true,
      // tipo de reporte activo (1=12h,2=24h,3=48h,4=72h,5=filtrado por fechas)
      tipoReporte: this.defaultTipoReporte,
      // filtros de fecha en formato input datetime-local (string como "YYYY-MM-DDTHH:mm")
      fechaInicioLocal: '',
      fechaFinLocal: '',
      showModal: false,
      periodicIntervalId: null,
      periodicIntervalMs: 60 * 60 * 1000, // 1 hora
      _lastFetchParams: null,
    };
  },
  computed: {
    // ✅ AÑADIR ESTA NUEVA PROPIEDAD COMPUTADA
    intervalLabels() {
      let totalHours = 0;

      switch (this.tipoReporte) {
        case 1: totalHours = 12; break;
        case 2: totalHours = 24; break;
        case 3: totalHours = 48; break;
        case 4: totalHours = 72; break;
        default: return []; // No mostrar etiquetas para filtro por fechas u otros
      }

      // Obtener la hora actual (hora final del reporte)
      const now = new Date();
      
      // Calcular la hora de inicio restando el total de horas
      const startTime = new Date(now.getTime() - (totalHours * 60 * 60 * 1000));
      
      const labels = [];
      const numIntervalos = 4;
      
      // Calcular el paso entre intervalos (en milisegundos)
      const stepMs = (totalHours * 60 * 60 * 1000) / (numIntervalos - 1);
      
      // Formateador para la hora (solo número de hora con AM/PM)
      const timeFormatter = new Intl.DateTimeFormat('es-CO', { 
        hour: 'numeric',
        hour12: true 
      });
      
      // Formateador para la fecha (dd/mm)
      const dateFormatter = new Intl.DateTimeFormat('es-CO', { 
        day: '2-digit',
        month: '2-digit'
      });
      
      // Función para crear etiqueta con fecha y hora separadas
      const createLabel = (date) => {
        const horaParte = timeFormatter.format(date); // Ej: "2 p. m."
        const fechaParte = dateFormatter.format(date); // Ej: "08/11"
        
        return {
          fecha: fechaParte,
          hora: horaParte,
          timestamp: date.getTime()
        };
      };
      
      // Generar los 4 intervalos
      for (let i = 0; i < numIntervalos; i++) {
        const intervalTime = new Date(startTime.getTime() + (stepMs * i));
        labels.push(createLabel(intervalTime));
      }
      
      // Verificar si hay cambio de día entre los intervalos
      // para determinar si se debe mostrar la fecha
      const uniqueDays = new Set(labels.map(label => {
        const d = new Date(label.timestamp);
        return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
      }));
      
      // Si hay más de un día, marcar que se debe mostrar la fecha
      const showDate = uniqueDays.size > 1;
      
      // Agregar la propiedad showDate a cada label
      labels.forEach(label => {
        label.showDate = showDate;
      });
      
      return labels;
    },

    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: 'kWh',
            data: this.values,
            backgroundColor: ['#0d6efd'],
            borderColor: ['#0d6efd'],
            fill: false,
            tension: 0.5
          }
        ]
      };
    },
    fechasValidas() {
      if (!this.fechaInicioLocal && !this.fechaFinLocal) return false;
      if (this.fechaInicioLocal && this.fechaFinLocal) {
        const a = new Date(this.fechaInicioLocal).getTime();
        const b = new Date(this.fechaFinLocal).getTime();
        return !Number.isNaN(a) && !Number.isNaN(b) && a <= b;
      }
      // allow open-ended filters (solo inicio o solo fin) -> consider valid
      return true;
    },
    // etiqueta que se muestra en la tarjeta cuando hay filtro por fechas (tipoReporte === 5)
    selectedRangeLabel() {
      if (this.tipoReporte !== 5) return '';
      const hasInicio = !!this.fechaInicioLocal;
      const hasFin = !!this.fechaFinLocal;
      if (!hasInicio && !hasFin) return '';
      const fmt = (s) => {
        if (!s) return null;
        const d = new Date(s);
        if (Number.isNaN(d.getTime())) return null;
        const datePart = d.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' });
        const timePart = d.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
        return `${datePart} ${timePart}`;
      };
      const inicio = fmt(this.fechaInicioLocal);
      const fin = fmt(this.fechaFinLocal);
      if (inicio && fin) return `Desde ${inicio} → Hasta ${fin}`;
      if (inicio) return `Desde ${inicio}`;
      if (fin) return `Hasta ${fin}`;
      return '';
    }
  },
  watch: {
    // si el padre envía lecturas explícitas (fallback), actualizamos
    lecturas: {
      immediate: true,
      handler(n) {
        if (Array.isArray(n) && n.length > 0) {
          this.loadFromLecturas(n);
        }
      }
    },
    // si cambia el defaultTipoReporte desde fuera, recargar
    defaultTipoReporte(n) {
      if (n) this.fetchLecturas(n);
    }
  },
  mounted() {
    // al montarse (y cada remount por key desde el padre) pedimos datos según tipoReporte
    this.fetchLecturas(this.tipoReporte);
    if (this.periodicIntervalId) clearInterval(this.periodicIntervalId);
    this.periodicIntervalId = setInterval(() => {
      const p = this._lastFetchParams || { tipo: this.tipoReporte, fechaInicioIso: null, fechaFinIso: null };
      // llamar con los mismos params de la última carga
      this.fetchLecturas(p.tipo ?? this.tipoReporte, p.fechaInicioIso ?? null, p.fechaFinIso ?? null);
    }, this.periodicIntervalMs);
  },
  beforeUnmount() {
    // limpiar intervalos
    if (this.periodicIntervalId) {
      clearInterval(this.periodicIntervalId);
      this.periodicIntervalId = null;
    }
  },
  methods: {
    openFechaModal() {
      // preabastecer modal con los valores actuales (ya están enlazados)
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    onLimpiarModal() {
      this.fechaInicioLocal = '';
      this.fechaFinLocal = '';
    },
    confirmarFiltro() {
      if (!this.fechasValidas) return;
      // console.log(this.fechaInicioLocal, this.fechaFinLocal);
      const inicioIso = this.fechaInicioLocal ? new Date(this.fechaInicioLocal).toISOString() : null;
      const finIso = this.fechaFinLocal ? new Date(this.fechaFinLocal).toISOString() : null;
      // console.log('Aplicando filtro fechas:', { inicioIso, finIso });
      // Forzar tipo_reporte = 5 cuando se aplica filtro por fechas
      this.tipoReporte = 5;
      this.fetchLecturas(5, inicioIso, finIso);
      this.closeModal();
    },

    onClickTipo(tipo) {
      if (this.tipoReporte === tipo) return;
      // al cambiar tipo, limpiar filtros de fecha (opcional) y recargar
      this.fechaInicioLocal = '';
      this.fechaFinLocal = '';
      this.fetchLecturas(tipo);
      // cerrar modal si estaba abierto
      this.closeModal();
    },

    refreshData() {
      // Ejecutar refresh manual con los parámetros actuales
      const p = this._lastFetchParams || { tipo: this.tipoReporte, fechaInicioIso: null, fechaFinIso: null };
      // console.log('🔄 [ConsumoHora] Refresh manual solicitado');
      this.fetchLecturas(p.tipo ?? this.tipoReporte, p.fechaInicioIso ?? null, p.fechaFinIso ?? null);
    },

    getAxisLabelStyle(index) {
      // Distribuir 4 intervalos equitativamente
      const totalIntervals = this.intervalLabels.length;
      if (totalIntervals === 0) return {};
      
      // Calcular la posición en porcentaje
      // Para 4 intervalos: 0%, 33.33%, 66.66%, 100%
      const position = (index / (totalIntervals - 1)) * 100;
      
      return {
        left: `${position}%`,
        transform: index === 0 ? 'translateX(0)' : 
                   index === totalIntervals - 1 ? 'translateX(-100%)' : 
                   'translateX(-50%)'
      };
    },

    async fetchLecturas(tipo, fechaInicioIso = null, fechaFinIso = null) {
      this.tipoReporte = tipo;
      // almacenar parametros para reusar en el fetch periódico
      this._lastFetchParams = { tipo, fechaInicioIso: fechaInicioIso || null, fechaFinIso: fechaFinIso || null };
      this.loading = true;
      try {
        const params = { tipo_reporte: tipo };
        if (fechaInicioIso) params.fecha_inicio = fechaInicioIso;
        if (fechaFinIso) params.fecha_fin = fechaFinIso;

        const resp = await axios.post('/api/lecturas-por-tipo-reporte', params, {
          headers: { Authorization: `Bearer ${this.$store?.state?.user?.token || ''}` }
        });
        // console.log('Respuesta lecturas por tipo reporte:', resp.data);
        const rows = resp.data.lecturas ?? resp.data ?? [];
        // procesar y mostrar
        this.loadFromLecturas(Array.isArray(rows) ? rows : []);
      } catch (err) {
        console.error('Error fetchLecturas:', err);
        // si falla, mostrar vacio para evitar spinner infinito
        this.labels = [];
        this.values = [];
        this.loading = false;
      }
    },

    limpiarFiltro() {
      this.fechaInicioLocal = '';
      this.fechaFinLocal = '';
      // si estaba activo el filtro por fechas, volver al tipo por defecto
      if (this.tipoReporte === 5) {
        this.tipoReporte = this.defaultTipoReporte;
      }
      // recargar datos sin filtros (manteniendo tipoReporte actual)
      this.fetchLecturas(this.tipoReporte);
    },

    loadFromLecturas(rows) {
        // Agrupa por hora (inicio de la hora) y genera etiquetas localizadas.
        if (!Array.isArray(rows) || rows.length === 0) {
        this.labels = [];
        this.values = [];
        this.loading = false;
        return;
        }

        this.loading = true;

        // Map: hourStartTs (number) -> sum energia
        const map = new Map();

        let energia = 0;
        rows.forEach(r => {
            const rawTs = r.timestamp ?? null;
            if (!rawTs) return;
            const d = new Date(rawTs);
            if (Number.isNaN(d.getTime())) return;

            // hora inicio (ms) para agrupar (misma hora del mismo día)
            const hourStart = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), 0, 0, 0).getTime();

            try {
                energia = Number(this.calcularEnergiaConsumida(r)) || 0;
            } catch (e) {
                energia = Number(r.valor ?? r.valor_kwh ?? r.kwh ?? r.energy ?? r.value ?? 0) || 0;
            }

            energia = energia / 1000; // convertir a kWh si está en Wh

            map.set(hourStart, (map.get(hourStart) || 0) + energia);
        });

        // Ordenar por timestamp de la hora asc
        const entries = Array.from(map.entries()).sort((a, b) => a[0] - b[0]);

        // Detectar si hay más de un día en los datos (para incluir fecha en la etiqueta si es necesario)
        const uniqueDays = new Set(entries.map(e => {
            const d = new Date(Number(e[0]));
            return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
        }));

        const showDateInLabel = uniqueDays.size > 1;

        // Formateador localizado
        const timeFormatter = new Intl.DateTimeFormat('es-CO', { hour: '2-digit', minute: '2-digit' });
        const dateFormatter = new Intl.DateTimeFormat('es-CO', { day: '2-digit', month: '2-digit' });

        this.labels = entries.map(([ts]) => {
        const d = new Date(Number(ts));
        const timePart = timeFormatter.format(d); // e.g. "14:00"
        if (showDateInLabel) {
            const datePart = dateFormatter.format(d); // e.g. "20/10"
            return `${datePart} ${timePart}`;
        }
        return timePart;
        });

        // ✅ CAMBIO CRÍTICO: Cada intervalo inicia desde 0 (no acumulativo)
        this.values = entries.map(([timestamp, sum]) => {
            // Cada valor es independiente por intervalo de hora
            return Number((sum || 0).toFixed(2));
        });

        // console.log('ConsumoHora - datos procesados:', { labels: this.labels, values: this.values });

        this.loading = false;
    },
    calcularEnergiaConsumida(lectura) {
        // console.log('Calculando energia consumida para lectura:', lectura);
        if (!lectura) return 0;
        let potencia = 0;
        if (typeof lectura.tiporede_id !== 'undefined') {
            if (lectura.tiporede_id === 1 || lectura.tiporede_id === 2) potencia = Number(lectura.potencia_exterior || 0) + Number(lectura.potencia_interior || 0);
            else potencia = (3 * Number(lectura.potencia_exterior || 0) * 0.98) + Number(lectura.potencia_interior || 0);
            const tiempoOn = Number(lectura.tiempo_on || 0); // segundos
            return (String(lectura.estado).toUpperCase() === 'ON') ? (potencia * (tiempoOn / 3600)) : 0;
        }
        return Number(lectura.valor ?? lectura.valor_kwh ?? lectura.kwh ?? lectura.energy ?? lectura.value ?? 0) || 0;
    }
  }
};
</script>

<style scoped>
.card-placeholder { min-height: 120px; padding: 0.5rem; box-sizing: border-box; }
.spinner-wrap { display:flex; align-items:center; justify-content:center; height:100%; }

/* forzar que la card no deje escapar el gráfico */
.card { 
  border-radius: 0.5rem; 
  overflow: hidden; 
  margin-bottom: 0;
  padding-bottom: 0 !important;
}

/* control del espacio interior - espacio para etiquetas */
.card-body { 
  padding: 0.75rem 0.75rem 45px 0.75rem !important; /* más espacio inferior para etiquetas de 2 líneas */
  margin-bottom: 0 !important;
}

/* header */
.card-header { display:flex; align-items:center; justify-content:space-between; padding:0.5rem 0.75rem; background: #f8f9fb; border-bottom: 1px solid rgba(0,0,0,0.05); }
.card-title { font-weight:600; }

/* contenedor que limita el tamaño del gráfico */
.chart-container { 
  width: 100%; 
  height: 100%;
  display: flex; 
  justify-content: center; 
  align-items: stretch;
  margin-bottom: 0;
  padding-bottom: 0;
  overflow: hidden;
}

/* wrapper que define la altura disponible para el chart */
.chart-wrapper {
  width: 100%;
  max-width: 100%;
  height: 100%;
  flex: 1;
  position: relative;
  margin-bottom: 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

/* ✅ ESTILOS AJUSTADOS PARA EL EJE X PERSONALIZADO */
.custom-x-axis {
  position: relative;
  width: 90%;
  height: 40px; /* Aumentado para acomodar hora + fecha */
  margin-top: 5px;
  z-index: 100;
  margin-left: 10%; /* espacio para evitar solapamiento con el borde derecho */
}

.axis-label {
  position: absolute;
  color: #495057;
  background: rgba(255, 255, 255, 0.95);
  padding: 4px 8px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.label-hora {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  color: #343a40;
}

.label-fecha {
  font-size: 0.65rem;
  font-weight: 500;
  line-height: 1;
  color: #6c757d;
}

/* asegurar que el canvas ocupe el 100% del wrapper sin "salirse" */
.chart-wrapper canvas,
.chart-wrapper .chartjs-render-monitor {
  width: 100% !important;
  height: 100% !important;
  display: block;
  margin-bottom: 0;
  padding-bottom: 0;
}

/* Eliminar cualquier espacio del componente Chart interno */
:deep(.chart-container) {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

:deep(canvas) {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

/* pequeños ajustes de espaciado */
.d-flex.gap-2 { gap: 0.5rem; }
.form-control-sm { max-width: 210px; }

/* Estilo para el botón de refresh */
.refresh-btn {
  min-width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.refresh-btn:hover:not(:disabled) {
  transform: rotate(180deg);
}

.refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.selected-range {
  white-space: normal;
  max-width: 100%;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
  text-align: right;
  line-height: 1.1;
}
</style>